import {
  IInvoiceNoReq,
  IInvoiceNoRes,
  IReceiptNoReq,
  IReceiptNoRes,
  IServerInfoRes,
} from '@/interfaces/misc';
import * as baseAdapter from './baseAdapter';

export const getServerInfo = async () => {
  const ret = await baseAdapter.get<IServerInfoRes>(`/v1/misc/server-info`);
  return ret;
};

export const searchReceiptNo = async (req: IReceiptNoReq) => {
  const ret = await baseAdapter.post<IReceiptNoRes>(
    '/v1/misc/get-receipt-no',
    req
  );
  return ret;
};

export const searchInvoiceNo = async (req: IInvoiceNoReq) => {
  const ret = await baseAdapter.post<IInvoiceNoRes>(
    '/v1/misc/get-invoice-no',
    req
  );
  return ret;
};
